import { useReducer, useCallback } from 'react'

export interface AdminFilters {
  search?: string
  page: number
  pageSize: number
  sortBy: string
  sortOrder: 'asc' | 'desc'
}

const DEFAULT_FILTERS: AdminFilters = {
  page: 1,
  pageSize: 20,
  sortBy: 'createdAt',
  sortOrder: 'desc',
}

type Action =
  | { type: 'SET'; payload: Partial<AdminFilters> }
  | { type: 'RESET' }

function reducer(state: AdminFilters, action: Action): AdminFilters {
  switch (action.type) {
    case 'SET':
      return { ...state, ...action.payload }
    case 'RESET':
      return { ...DEFAULT_FILTERS }
  }
}

export function useAdminFilters(defaults?: Partial<AdminFilters>) {
  const initial = { ...DEFAULT_FILTERS, ...defaults }
  const [filters, dispatch] = useReducer(reducer, initial)

  const setFilters = useCallback((partial: Partial<AdminFilters>) => {
    dispatch({ type: 'SET', payload: partial })
  }, [])

  const resetFilters = useCallback(() => {
    dispatch({ type: 'RESET' })
  }, [])

  return { filters, setFilters, resetFilters }
}
